import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools, persist } from "zustand/middleware";
import localforage from "localforage";

type OfflineModeState = {
  isOffline: boolean;
};

type OfflineModeAction = {
  toggleOffline: () => void;
};

const defaultState: OfflineModeState = {
  isOffline: false,
};

export const useOfflineStore = create<OfflineModeState & OfflineModeAction>()(
  devtools(
    persist(
      immer((set) => ({
        ...defaultState,
        toggleOffline() {
          set((state) => {
            state.isOffline = !state.isOffline;
          });
        },
      })),
      {
        name: "offline-mode",
        storage: {
          getItem: (key: string): Promise<any> => localforage.getItem(key),
          setItem: (key: string, value: any): Promise<void> =>
            localforage.setItem(key, value),
          removeItem: (key: string): Promise<void> =>
            localforage.removeItem(key),
        },
        partialize: (state) => ({
          isOffline: state.isOffline, // ✅ only persist this
        }),
      }
    ),
    {
      name: "OfflineStore",
      enabled: true,
    }
  )
);
